import React, {  useEffect } from 'react';
import { Table, Input, Select } from 'antd';
import "./Table.css"

const expandedRowRender = (record: any) => {
    // console.log('REECORD: ', record);s
    const columns: any = [
      { 
        title: '#', 
        dataIndex: 'index', 
        key: 'index',
        render: (text: any, record: any, index: number) => index + 1, 
      },
      { 
        title: 'Report Owner', 
        dataIndex: 'owner', 
        key: 'owner' 
      },
      {
        title: 'Date Created', 
        dataIndex: 'created_at', 
        key: 'created_at' 
      },
      { 
        title: 'Action', 
        key: 'document_url', 
        dataIndex: "file_url",
        render: (text: any, record: any, index: number) => <a target='_blank' href={`${text}`}>View Report</a> },
    ];

    return <Table key={record.id} className="custom-table" columns={columns} dataSource={record?.reports?.map((item: any, index: any) => ({ ...item, index: item.file_url }))} pagination={false} /> ;
  };

function DataTable({ data }: any) {

  function formatFirebaseTimestamp(serverTimestamp: any) {
    // Create a new Date object using the serverTimestamp value
    const date = new Date(serverTimestamp.seconds * 1000);
  
    // Format the date components (day, month, year, hours, minutes, seconds)
    const formattedDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
    const formattedTime = `${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`;
  
    // Combine the formatted date and time
    const formattedDateTime = `${formattedDate}`;
  

    // Return the formatted date and time
    return formattedDateTime !== 'NaN-NaN-NaN' ? formattedDateTime : '-------';
  }

  
    const columns: any= [
        { 
          title: '#', 
          dataIndex: 'index', 
          key: 'index',
          render: (text: any, record: any, index: number) => index + 1,
        },
        { 
          title: 'Case Code', 
          dataIndex: 'CID', 
          key: 'CID',
          sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
        },
        {  
            title: 'Case Id', 
            dataIndex: 'id', 
            key: 'id',
            sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
          },
        { 
          title: 'Case Status', 
          dataIndex: 'reports', 
          // key: 'is_case_resolved' ,
          // sorter: (a: any, b: any) => (a.is_case_resolved ? 1 : -1) - (b.is_case_resolved ? 1 : -1),
          render: (reports: any) => (reports?.length > 0 ? <span style={{backgroundColor: '#219653', color: '#fff', padding: '5px'}}>Resolved</span> : <span  style={{backgroundColor: '#D42A2A', color: '#fff', padding: '5px'}}>Not Resolved</span>),
        },
        { 
            title: 'Category', 
            dataIndex: 'category', 
            key: 'category',
            sorter: (a: any, b: any) => a.phone.localeCompare(b.phone),
          },
        { 
          title: 'Date Created', 
          dataIndex: 'createdAt', 
          key: 'createdAt',
          render: (createdAt: any) => (createdAt ? formatFirebaseTimestamp(createdAt) : '---'), 
        },
      ];
  

    return (
        <Table
            columns={columns}
            expandable={{ expandedRowRender, defaultExpandedRowKeys: ['0'] }}
            dataSource={data.map((item: any, index: any) => ({ ...item, index: index + 1 }))}
      />
    );
}

export default DataTable;